export const globalServicesManager = {
  header: {
    title: "Usługi i atrakcje",
    description: "Jedna lista dla całego konta. Wpisz usługę raz i zaznacz, w których ofertach jest dostępna.",
  },

  toolbar: {
    info: "To, co tu utworzysz, pojawi się w Twoim <strong>silniku rezerwacji</strong> i na <strong>stronie</strong>, w zaznaczonych ofertach.",
    newService: "Nowa usługa",
  },

  loading: "Wczytywanie usług…",

  empty: {
    title: "Nie masz jeszcze usług",
    description: "Transfer, zwiedzanie z przewodnikiem, kosz powitalny… Gość dodaje je przy rezerwacji.",
    create: "Utwórz pierwszą",
  },

  status: {
    active: "Aktywna",
    paused: "Wstrzymana",
  },

  price: {
    onRequest: "Na zapytanie",
    free: "Bezpłatnie",
  },

  assign: {
    title: "W których ofertach",
    listingsLabel: "Twoje oferty",
    selectAll: "Zaznacz wszystkie",
    clearAll: "Odznacz wszystkie",
    inAll: "We wszystkich ofertach",
    inSome: "W {n} z {total}",
    units: "{n} jednostek",
    pickRooms: "Wybierz pokoje",
    hideRooms: "Ukryj pokoje",
    roomsHint: "Zaznacz tylko pokoje, w których jest oferowana. Bez zaznaczenia obowiązuje we wszystkich.",
    inRooms: "W 1 pokoju | W {count} pokojach",
    unassigned: "Nieprzypisana",
    helperNone: "Bez żadnego zaznaczenia ta usługa NIE jest nigdzie oferowana.",
    roomsChecked: "1 zaznaczony · wyczyść | {count} zaznaczone · wyczyść",
    andMore: "+1 więcej | +{count} więcej",
    helper: "Bez zaznaczenia usługa jest oferowana we wszystkich Twoich ofertach.",
  },

  actions: {
    edit: "Edytuj",
    delete: "Usuń",
    cancel: "Anuluj",
    save: "Zapisz",
  },

  delete: {
    title: "Usuń usługę",
    text: "„{name}” przestanie być oferowana we wszystkich ofertach. Tego nie można cofnąć.",
    accept: "Tak, usuń",
  },

  saved: {
    assign: "Oferty zaktualizowane",
    state: "Usługa zaktualizowana",
    deleted: "Usługa usunięta",
  },

  errors: {
    load: "Nie udało się wczytać Twoich usług.",
    assign: "Nie udało się zapisać ofert.",
    state: "Nie udało się zmienić usługi.",
    delete: "Nie udało się usunąć usługi.",
  },
};
